module.exports = __webpack_public_path__ + "media/images/icon__infoBox@3x-fa5b601d39ef1d689c205c9d081bdf43.png";